// extracted by mini-css-extract-plugin
export var layoutContainer = "_c0-0";
export var layoutContainerNoRounding = "_c0-6";
export var layoutContainerOpen = "_c0-5";
export var layoutContainerResizing = "_c0-1";
export var mainContent = "_c0-2";
export var resizeDivider = "_c0-3";
export var slidePanel = "_c0-4";